import { ChevronDown } from "lucide-react";
import type * as React from "react";
import { cn } from "../lib/utils.js";

export function NativeSelect({ className, children, ...props }: React.ComponentProps<"select">) {
  return (
    <span className={cn("relative block min-w-0", className)}>
      <select
        data-slot="native-select"
        className="ui-control ui-field h-8 w-full appearance-none rounded-md border border-input bg-background py-1 pr-8 pl-3 text-sm disabled:cursor-not-allowed disabled:opacity-50"
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute top-1/2 right-2 size-3.5 -translate-y-1/2 text-muted-foreground" />
    </span>
  );
}
